/** Public site name used in titles and Open Graph. */
export const SITE_NAME = 'Stavyn';

/** Marketing site origin for canonical and OG URLs (override via env in production). */
export const SITE_ORIGIN =
  (typeof process !== 'undefined' && process.env.REACT_APP_SITE_URL) ||
  'https://stavyn.com';

/** Default social preview image (absolute URL). */
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN.replace(/\/$/, '')}/favicon.png`;

export const DEFAULT_META = {
  title: 'Stavyn | AI-Powered Employee Retention & Turnover Prediction',
  description:
    'Stavyn uses AI to predict employee turnover months early and deliver retention playbooks. Identify flight risk, act before resignations, and protect top talent.',
  ogType: 'website',
  robots: 'index, follow',
};
